module.exports = __webpack_public_path__ + "static/headerhero@2x-899d47c47b76984dd827709c05c6cf8d.png";